

















































































import Vue from 'vue'
import _ from 'lodash'
import { TranslateResult } from 'vue-i18n'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import AllocationDialog from '@/components/disposition/AllocationDialog.vue'
import {
  DELETE_DISPOSITION_JOB,
  FETCH_DISPOSITION_ADDRESS_LIST,
  FETCH_DISPOSITION_JOB_LIST,
  SET_DISPOSITION_ADDRESS
} from '@/store/action-types'
import { DispositionJob } from '@/model/disposition/DispositionJob'
import { DispositionAddress } from '@/model/disposition/DispositionAddress'
import { GET_DISPOSITION_ADDRESS } from '@/store/getter-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import moment from 'moment'
import ActiveCellRendererDX from '@/components/cell-renderer/ActiveCellRendererDX.vue'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}
class Search extends KeyAction {}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  showAll: boolean
  addressList: DispositionAddress[]
  dispositionJobList: DispositionJob[]
  gridData: DispositionJob[]
  currentSelectedRowData: DispositionJob | undefined
  showDialog: boolean
  showDeleteDialog: boolean
  dispositionAddress: number | undefined
  tableHeight: string
  showSearchField: boolean
  search: string | null
  loading: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'Allocation',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    ActiveCellRendererDX,
    DeleteDialog,
    AllocationDialog,
    ProgressCircular
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      showAll: false,
      addressList: [],
      dispositionJobList: [],
      gridData: [],
      currentSelectedRowData: undefined,
      showDialog: false,
      showDeleteDialog: false,
      dispositionAddress: undefined,
      tableHeight: '',
      showSearchField: false,
      search: null,
      loading: false,

      keyActions: []
    }
  },

  watch: {},

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEnableEditButton (): boolean {
      return !!(this.currentSelectedRowData && this.currentSelectedRowData.id)
    },

    isEnableDeleteButton (): boolean {
      return !!(this.currentSelectedRowData && this.currentSelectedRowData.id && this.currentSelectedRowData.status !== 3)
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    setShowButtonIcon (): string {
      if(this.showAll) {
        return 'visibility'
      } else {
        return 'visibility_off'
      }
    },

    isSearchEnabled (): boolean {
      return this.gridData.length > 0
    },

    filteredGridData (): any[] {
      this.currentSelectedRowData = undefined
      //@ts-ignore
      setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)

      if(this.search) {
        return this.gridData.filter((item: DispositionJob) => {
          return item.address.toLowerCase().includes(this.search!.toLowerCase())
        })
      } else {
        return this.gridData
      }
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | Search | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return this.isEnableEditButton
      } else if(action instanceof Delete) {
        return this.isEnableDeleteButton
      } else if(action instanceof Search) {
        return this.isSearchEnabled
      } else {
        return false
      }
    },

    formatDateToDate(item: string): string {
      return moment(item, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(item, 'DD.MM.YYYY HH:mm:ss').toISOString() : ''
    },

    onRowClick (rowData: any): void {
      this.currentSelectedRowData = rowData.data
    },

    onRowDblClick (rowData: any): void {
      this.currentSelectedRowData = rowData.data
      this.showDialog = true
    },

    onShowDispositionJobs (): void {
      this.currentSelectedRowData = undefined
      //@ts-ignore
      setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)

      this.showAll = !this.showAll

      if(this.showAll) {
        this.gridData = _.cloneDeep(this.dispositionJobList)
      } else {
        this.gridData = this.dispositionJobList.filter((item: DispositionJob) => item.status !== 3)
      }
    },

    onAddDispositionClick (): void {
      this.currentSelectedRowData = undefined
      //@ts-ignore
      setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)
      this.showDialog = true
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddDispositionClick()
    },

    onEditDispositionButtonClick (): void {
      this.showDialog = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditDispositionButtonClick()
    },

    dialogSaved (): void {
      this.closeDialog()
    },

    closeDialog (): void {
      this.dispositionAddress = undefined
      this.fetchData()
      this.showDialog = false
    },

    onDeleteDispositionButtonClick (): void {
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteDispositionButtonClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      if(this.currentSelectedRowData && this.currentSelectedRowData.personalDispositionJobDetailId) {
        this.deleteDispositionJob(this.currentSelectedRowData.personalDispositionJobDetailId)
      }
    },

    async deleteDispositionJob (payload: number): Promise<void> {
      try {
        let response: boolean = await this.$store.dispatch(DELETE_DISPOSITION_JOB, payload)
        if(response) {
          this.onDeleteDialogClose()
          this.fetchData()
          this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      this.currentSelectedRowData = undefined
      //@ts-ignore
      setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)

      this.loading = true
      try {
        this.dispositionJobList = await this.$store.dispatch(FETCH_DISPOSITION_JOB_LIST, false)

        if (this.showAll) {
          this.gridData = this.dispositionJobList
        } else {
          this.gridData = this.dispositionJobList.filter((item: DispositionJob) => item.status !== 3)
        }
      } catch {

      } finally {
        this.loading = false
      }
    },

    async fetchAddressList (): Promise<void> {
      this.loading = true
      try {
        this.addressList = await this.$store.dispatch(FETCH_DISPOSITION_ADDRESS_LIST)
        if(this.dispositionAddress && this.addressList) {
          const foundAddress: DispositionAddress | undefined = this.addressList.find((item: DispositionAddress) => item.id === this.dispositionAddress)
          if(foundAddress) {
            this.showDialog = true
          } else {
            this.dispositionAddress = undefined
          }
        } else {
          this.dispositionAddress = undefined
        }
      } catch {

      } finally {
        this.loading = false
      }
    },

    onSearchButtonClick (): void {
      this.showSearchField = !this.showSearchField
      if(!this.showSearchField) {
        this.search = null
      }
    },

    searchClick (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      this.onSearchButtonClick()
    },

    onResize (): void {
      const vh = window.innerHeight
      if(vh > 405) {
        this.tableHeight = `height: calc(${vh}px - 136px)`
      } else {
        this.tableHeight = 'height: 300px'
      }
    },
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
      new Search(KeyActionEnum.search, this.searchClick, this.resolver, null)
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    this.dispositionAddress = this.$store.getters[GET_DISPOSITION_ADDRESS]
    this.$store.dispatch(SET_DISPOSITION_ADDRESS, undefined)
    this.fetchData()
    this.fetchAddressList()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
